import { IAreaData } from "@/components/map-container/types/map-type";
import { WarningSchema } from "@/schemas/warning-data-schema";
import { getColorStatusByColor } from "./get-color-by-value";
import { AreaPolygonType } from "../types/area-polygon-type";

type formatAreaDataParams = {
	areaData: IAreaData[];
	warningData: WarningSchema[];
	filter?: string;
};

export const formatAreaData = ({
	areaData,
	warningData,
	filter,
}: formatAreaDataParams): AreaPolygonType => { 
	const formattedFilter = filter?.toLowerCase().split(" ").at(-1);

	const warningsByGeometry = warningData.reduce((acc, warning) => {
		const id = warning.geometry_id;

		if (!acc.has(id)) {
			acc.set(id, []);
		}

		acc.get(id)!.push(warning);
		return acc;
	}, new Map<string, (typeof warningData)[number][]>());

	return areaData.map((area) => { 
		const warnings = warningsByGeometry.get(area.id);

		if (!warnings?.length) { 
			return area;
		}

		const filteredWarnings = formattedFilter
			? warnings.filter(
					(w) =>
						w.properties["event_en-US"]
							?.toLowerCase()
							.includes(formattedFilter),
			  )
			: warnings;
 


		if (!filteredWarnings.length) { 
			return {
				...area,
				color: getColorStatusByColor(1),
			};
		}

		const highestWarning = filteredWarnings.reduce((prev, current) =>
			current.properties.value > prev.properties.value ? current : prev,
		);

		const { layer, value } = highestWarning.properties;

		const type = layer.split("_")[0];

		return {
			...area,
			type,
			color: getColorStatusByColor(value),
		};
	});
};
